import { useLocations, useSelectedLocation } from '../../../hooks';

import { Select } from '@pella/sash-framework';

/**
 * Location selection atom component.
 * @param {Local.SelectionComponentsProps} props - Component props.
 */
export const SelectLocation = ({ id = 'location-selection', hideInactive = true }) => {
  const { data: locations } = useLocations(hideInactive);
  const { selectedLocation, setSelectedLocation } = useSelectedLocation();

  /**
   * Handles changes to the selected location.
   * @param {React.ChangeEvent<HTMLSelectElement>} event - The change event object.
   * @returns {void}
   */
  const handleLocationChange = ({ target: { value } }) => {
    if (value) setSelectedLocation(value);
  };

  return (
    <Select
      id={id}
      data-testid={id}
      labelText='Select Location'
      onChange={handleLocationChange}
      value={selectedLocation}
    >
      <option value=''>--- Select an Option ---</option>
      {locations?.map((location) => (
        <option key={location.id} value={location.id}>
          {location.description}
        </option>
      ))}
    </Select>
  );
};
